import { Menu } from 'antd';
import { Box, Button } from 'glints-aries';
import { Badge } from 'glints-aries/es/@next';
import { Blue, Neutral } from 'glints-aries/es/@next/utilities/colors';
import { space4, space12 } from 'glints-aries/es/@next/utilities/spacing';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { desktopNavbarHeight } from './Navbar.sc';
import { dropdownMenuItemStyles } from './NavbarCommon.sc';
import { NavbarItem } from './NavbarItem';

export const DropdownLink = styled.a.attrs({
  className: 'ant-dropdown-link',
})`
  display: flex;
  height: 100%;
  align-items: center;
`;

export const DropdownLinkLabel = styled.span`
  margin-right: 5px;
`;

export const DropdownMenu = styled(Menu)`
  ${dropdownMenuItemStyles}
`;

export const Messages = styled(Box)`
  a {
    color: #656565;
  }

  svg {
    width: 21px;
    height: 21px;
  }
`;

export const StyledNavbarItem = styled(NavbarItem)`
  a {
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;

export const StyledButton = styled(Button)`
  button {
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;

export const StyledBadge = styled(Badge).attrs({
  status: 'enticing',
})`
  text-transform: uppercase;
  span {
    font-size: 10px;
    letter-spacing: 0.2px;
  }
`;

export const DesktopNavbarLogo = styled(Link)`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  height: ${desktopNavbarHeight};

  img {
    width: auto;
    height: 32px;
  }
`;

export const DesktopLeftSection = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  min-width: 0;
  height: ${desktopNavbarHeight};
  gap: 20px;
  overflow: hidden;
`;

export const HeaderNavigation = styled.nav`
  display: flex;
  flex: 0 1 auto;
  align-items: center;
  min-width: 0;
  height: ${desktopNavbarHeight};

  > div,
  > button {
    flex: 0 0 auto;
  }

  button {
    width: auto;
    height: ${desktopNavbarHeight};
    color: ${Neutral.B18};
  }

  button > span {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 ${space12};
  }

  button > span::before {
    bottom: 0;
    height: 2px;
  }

  button span {
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.25px;
  }

  button[data-selected='true'] {
    color: ${Blue.S99};
  }
`;

export const DesktopRightSection = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  height: ${desktopNavbarHeight};
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${space12};

  button {
    padding: ${space4} ${space12};
  }

  button > svg {
    width: 18px;
    height: 18px;
  }
`;

export const HeaderDivider = styled.div`
  width: 1px;
  height: 16px;
  margin: 0 16px;
  background: ${Neutral.B85};
`;

export const HeaderUserMenu = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderLanguageMenu = styled.div`
  display: flex;
  align-items: center;
`;
